var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header row" }, [
      _c(
        "div",
        [
          _vm.latestUpdateOn
            ? _c("HKLGrayHint", [
                _vm._v("\n        " + _vm._s(_vm.latestUpdateOn) + "\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("hint.regionConfig.limitImg")) +
                "\n      "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canEdit
        ? _c(
            "div",
            { staticClass: "btn-group" },
            [
              !_vm.isEdit
                ? _c("HKLButton", {
                    attrs: { color: "orange", action: "edit" },
                    on: { click: _vm.changeEdit },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isEdit
                ? _c("HKLButton", {
                    attrs: { color: "darkblue", action: "cancel" },
                    on: { click: _vm.cancelEdit },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isEdit
                ? _c("HKLButton", {
                    attrs: { color: "orange", action: "save" },
                    on: { click: _vm.saveTmpImg },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "region-image-body" },
      _vm._l(_vm.imageList, function (item, index) {
        return _c(
          "div",
          {
            key: "region-image-" + index,
            staticClass: "row",
            class: _vm.isEdit ? "edit-mode-row" : "view-mode-row",
          },
          [
            _c(
              "div",
              { staticClass: "region-image-label small-3" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "settings.regionConfig.imagesTitle." +
                          item.label +
                          ".label"
                      )
                    ) +
                    "\n        "
                ),
                _c(
                  "HKLGrayHint",
                  { staticClass: "region-image-desc font-size-14" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "settings.regionConfig.imagesTitle." +
                              item.label +
                              ".desc"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isEdit
              ? _c(
                  "div",
                  { staticClass: "upload-area small-5" },
                  [
                    _c("HkldDropzone", {
                      attrs: {
                        sourceId: _vm.sourceId,
                        maxNumberOfFiles: 1,
                        uploadDocTypes: "image/png",
                        customUrl: "region-images/upload",
                        metaData: { name: item.name },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasImg(item.name, _vm.fullList)
              ? _c(
                  "div",
                  { staticClass: "region-image-uploaded-file small-3" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "link_text",
                        on: {
                          click: function ($event) {
                            return _vm.download(item.name)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.name) + "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.fileOriginNameMap[item.name]
                      ? _c("HKLGrayHint", { staticClass: "font-size-14" }, [
                          _vm._v(
                            "\n          (" +
                              _vm._s(
                                _vm.$t("settings.regionConfig.originFileName")
                              ) +
                              ": " +
                              _vm._s(_vm.fileOriginNameMap[item.name]) +
                              ")\n        "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }